import { z } from "zod";
import { zChaveDaIa, zEstadoDaIa, zBlocoExtraido, zItensGerados, zPedidoDeExtracao, zPedidoDeItensIa, zPerguntaDaIa, zRespostaDaIa, } from "./ia.js";
import { zEntrarEntrada, zOk, zRedefinirSenhaEntrada, zSaude, zSessaoAtual } from "./dominio.js";
import { zTrilha, zTrilhaEntrada, zTrilhaExclusao, zTrilhaArquivamento, zTrilhaId, zTrilhaLista, zTrilhaSelecao, zTrilhaUma, } from "./trilha.js";
import { zAjustarEntrada, zEncerrarEntrada, zEstudoAtual, zMontagem, zDisponiveis, zMontarEntrada, zOpcoesEstudo, zResponderEntrada, zRespostaDada, zAgendamentoVisivel, zPacoteOffline, } from "./estudo.js";
import { zDiagnosticoDeErros, zPeriodoParam } from "./diagnostico.js";
import { zAnotacaoRapidaEntrada, zMural, zMuralId, zOrdemDoMural, zPosicaoNoMural } from "./mural.js";
import { zPainelDeRevisao } from "./revisao.js";
import { zDosagemEntrada, zFeriasEntrada, zPainelDaHome } from "./home.js";
import { zOfensiva } from "./ofensiva.js";
import { zConsultaDeEstatisticas, zPainelDeEstatisticas } from "./estatistica.js";
import { zExportacao } from "./exportacao.js";
import { zCredencialId, zEntradaComPasskey, zListaDeCredenciais, zOpcoesDaCerimonia, zRegistroDePasskey, } from "./passkey.js";
import { zModeloProva, zModeloProvaEntrada, zModeloProvaId, zMontarSimulado, zPainelDoSimulado, zRelatorioDeSimulado, zSimuladoId, } from "./simulado.js";
import { zItemAlvo, zListaDeMarcados, zMarcacaoAlterada } from "./estudo-eixos.js";
import { zConfirmarImportacao, zImportacaoEntrada, zImportacaoFeita, zListaDeLotes, zLoteExclusao, zLoteId, zRelatorio, } from "./importar-contrato.js";
import { zConsultaDeNotas, zDuvidaId, zArquivoParaConverter, zFonteEntrada, zFonteId, zTextoDaFonte, zListaDeCategorias, zListaDeDuvidas, zListaDeFontes, zListaDeNotas, zNaoEntendiEntrada, zNaoEntendiResposta, zNotaEntrada, zNotaId, zNotaSalva, zNotaUma, zResolverDuvida, zNotaDoAssunto, zContextoDoItem, zSalvarNota, } from "./caderno.js";
import { zTour } from "./tour.js";
export const contrato = {
    "saude.ver": {
        metodo: "GET",
        caminho: "/api/saude",
        params: null,
        corpo: null,
        resposta: zSaude,
        autenticada: false,
    },
    "sessao.entrar": {
        metodo: "POST",
        caminho: "/api/sessao",
        params: null,
        corpo: zEntrarEntrada,
        resposta: zSessaoAtual,
        autenticada: false,
    },
    "sessao.atual": {
        metodo: "GET",
        caminho: "/api/sessao",
        params: null,
        corpo: null,
        resposta: zSessaoAtual,
        autenticada: true,
    },
    "sessao.sair": {
        metodo: "DELETE",
        caminho: "/api/sessao",
        params: null,
        corpo: null,
        resposta: zOk,
        autenticada: true,
    },
    /**
     * A única rota que atravessa a trava de `deve_redefinir_senha` — é ela que
     * desliga a trava. Ver `TRAVA_LIBERA` em `rotas.ts`.
     */
    "sessao.redefinirSenha": {
        metodo: "PUT",
        caminho: "/api/sessao/senha",
        params: null,
        corpo: zRedefinirSenhaEntrada,
        resposta: zSessaoAtual,
        autenticada: true,
    },
    // --- passkey (RN-36) ---
    //
    // As duas rotas de entrada são públicas, como o login por senha: quem está
    // entrando ainda não tem sessão. As de cadastro e remoção são autenticadas —
    // cadastrar aparelho novo exige já estar dentro, e é assim que o segundo
    // aparelho entra em cena: entra-se com a senha nele e cadastra-se ali.
    "sessao.passkeyOpcoes": {
        metodo: "POST",
        caminho: "/api/sessao/passkey/opcoes",
        params: null,
        corpo: null,
        resposta: zOpcoesDaCerimonia,
        autenticada: false,
    },
    "sessao.passkeyEntrar": {
        metodo: "POST",
        caminho: "/api/sessao/passkey",
        params: null,
        corpo: zEntradaComPasskey,
        resposta: zSessaoAtual,
        autenticada: false,
    },
    "passkey.listar": {
        metodo: "GET",
        caminho: "/api/passkeys",
        params: null,
        corpo: null,
        resposta: zListaDeCredenciais,
        autenticada: true,
    },
    "passkey.opcoesRegistro": {
        metodo: "POST",
        caminho: "/api/passkeys/opcoes",
        params: null,
        corpo: null,
        resposta: zOpcoesDaCerimonia,
        autenticada: true,
    },
    "passkey.registrar": {
        metodo: "POST",
        caminho: "/api/passkeys",
        params: null,
        corpo: zRegistroDePasskey,
        resposta: zListaDeCredenciais,
        autenticada: true,
    },
    "passkey.excluir": {
        metodo: "POST",
        caminho: "/api/passkeys/:id/exclusao",
        params: zCredencialId,
        corpo: null,
        resposta: zListaDeCredenciais,
        autenticada: true,
    },
    // --- trilhas (RN-01, RN-04) ---
    "trilha.listar": {
        metodo: "GET",
        caminho: "/api/trilhas",
        params: null,
        corpo: null,
        resposta: zTrilhaLista,
        autenticada: true,
    },
    "trilha.criar": {
        metodo: "POST",
        caminho: "/api/trilhas",
        params: null,
        corpo: zTrilhaEntrada,
        resposta: zTrilhaUma,
        autenticada: true,
    },
    "trilha.ver": {
        metodo: "GET",
        caminho: "/api/trilhas/:id",
        params: zTrilhaId,
        corpo: null,
        resposta: zTrilhaUma,
        autenticada: true,
    },
    "trilha.editar": {
        metodo: "PUT",
        caminho: "/api/trilhas/:id",
        params: zTrilhaId,
        corpo: zTrilhaEntrada,
        resposta: zTrilhaUma,
        autenticada: true,
    },
    "trilha.arquivar": {
        metodo: "POST",
        caminho: "/api/trilhas/:id/arquivamento",
        params: zTrilhaId,
        corpo: zTrilhaArquivamento,
        resposta: zTrilhaUma,
        autenticada: true,
    },
    /**
     * A exclusão exige o nome digitado (RN-25 e invariante 11) e a conferência é
     * do servidor, não da tela: interface é conveniência, regra é da API.
     */
    "trilha.excluir": {
        metodo: "POST",
        caminho: "/api/trilhas/:id/exclusao",
        params: zTrilhaId,
        corpo: zTrilhaExclusao,
        resposta: zTrilhaSelecao,
        autenticada: true,
    },
    "trilha.ativar": {
        metodo: "POST",
        caminho: "/api/trilhas/:id/ativacao",
        params: zTrilhaId,
        corpo: null,
        resposta: zTrilhaSelecao,
        autenticada: true,
    },
    // --- sessão de estudo ---
    //
    // Vive em `/api/estudo/*`, não em `/api/sessao/*`: `sessao` já é a sessão de
    // autenticação, e duas coisas diferentes com o mesmo nome numa URL é a
    // origem de um bug que ninguém acha.
    "estudo.ver": {
        metodo: "GET",
        caminho: "/api/estudo",
        params: null,
        corpo: null,
        resposta: zEstudoAtual,
        autenticada: true,
    },
    "estudo.opcoes": {
        metodo: "GET",
        caminho: "/api/estudo/opcoes",
        params: null,
        corpo: null,
        resposta: zOpcoesEstudo,
        autenticada: true,
    },
    "estudo.montar": {
        metodo: "POST",
        caminho: "/api/estudo",
        params: null,
        corpo: zMontarEntrada,
        resposta: zMontagem,
        autenticada: true,
    },
    /**
     * Quantos itens o filtro alcança **sem montar nada**.
     *
     * Rota própria e não um campo de `estudo.opcoes`: as opções são o que existe
     * para filtrar, e isto é o que um filtro específico alcança. A tela de montar
     * pergunta a cada mudança, e montar tem efeito — encerra a sessão anterior e
     * grava uma nova. Perguntar não pode custar isso.
     */
    "estudo.disponiveis": {
        metodo: "POST",
        caminho: "/api/estudo/disponiveis",
        params: null,
        corpo: zMontarEntrada,
        resposta: zDisponiveis,
        autenticada: true,
    },
    "estudo.responder": {
        metodo: "POST",
        caminho: "/api/estudo/respostas",
        params: null,
        corpo: zResponderEntrada,
        resposta: zRespostaDada,
        autenticada: true,
    },
    /**
     * Os dois toques opcionais do feedback, "foi difícil" e "foi fácil".
     * Recalculam o agendamento; não reescrevem a resposta (invariante 12).
     */
    // --- ritual: home, ofensiva, férias e dosagem ---
    "home.painel": {
        metodo: "GET",
        caminho: "/api/home",
        params: null,
        corpo: null,
        resposta: zPainelDaHome,
        autenticada: true,
    },
    /**
     * A ofensiva sozinha, sem o resto do painel.
     *
     * Existe porque a ofensiva saiu do painel do dia e foi para a barra lateral,
     * que está em **toda** tela — e carregar os 365 dias do heatmap para desenhar
     * um número na barra seria pagar o painel inteiro em cada rota do app.
     *
     * `ofensiva` é anulável de propósito: sem trilha ativa não há ofensiva, e
     * isso é estado de produto (RN-04), não erro. Devolver 409 aqui encheria o
     * console de quem ainda não escolheu trilha com uma falha que não é falha.
     */
    "ritual.ofensiva": {
        metodo: "GET",
        caminho: "/api/ofensiva",
        params: null,
        corpo: null,
        resposta: z.object({ ofensiva: zOfensiva.nullable() }),
        autenticada: true,
    },
    // --- tour de primeiro uso (ADR 041) ---
    /**
     * Onde a conta parou no tour. Conta que nunca o viu devolve passo -1 e
     * `concluido` falso — ausência de linha não é erro.
     */
    "tour.ver": {
        metodo: "GET",
        caminho: "/api/tour",
        params: null,
        corpo: null,
        resposta: zTour,
        autenticada: true,
    },
    "tour.gravar": {
        metodo: "PUT",
        caminho: "/api/tour",
        params: null,
        corpo: zTour,
        resposta: zTour,
        autenticada: true,
    },
    // --- exportação (RN-35) ---
    /**
     * O arquivo inteiro numa resposta só, e os dois downloads montados no
     * navegador a partir dela. É uma rota de leitura como qualquer outra: o
     * contrato continua sendo a única lista de rotas, e o `pedir` do front
     * confere a resposta contra o mesmo schema (invariante 2).
     */
    "exportacao.tudo": {
        metodo: "GET",
        caminho: "/api/exportacao",
        params: null,
        corpo: null,
        resposta: zExportacao,
        autenticada: true,
    },
    /** O retrato de onde se erra (RN-46). Distinto da fila de erradas. */
    /**
     * O período entra no **caminho**, e não numa string de consulta: o contrato
     * interpola `:params` e não conhece query. Uma rota por janela seria a mesma
     * conta escrita quatro vezes; um parâmetro fechado em `zPeriodoDoDiagnostico`
     * é uma rota só, com o valor validado pelo mesmo schema dos dois lados.
     */
    "diagnostico.erros": {
        metodo: "GET",
        caminho: "/api/diagnostico/erros/:periodo",
        params: zPeriodoParam,
        corpo: null,
        resposta: zDiagnosticoDeErros,
        autenticada: true,
    },
    // --- mural de anotações rápidas do início (RN-50) ---
    "mural.listar": {
        metodo: "GET",
        caminho: "/api/mural",
        params: null,
        corpo: null,
        resposta: zMural,
        autenticada: true,
    },
    "mural.criar": {
        metodo: "POST",
        caminho: "/api/mural",
        params: null,
        corpo: zAnotacaoRapidaEntrada,
        resposta: zMural,
        autenticada: true,
    },
    "mural.editar": {
        metodo: "PUT",
        caminho: "/api/mural/:id",
        params: zMuralId,
        corpo: zAnotacaoRapidaEntrada,
        resposta: zMural,
        autenticada: true,
    },
    /** Só a posição, chamada por debounce durante o arrasto (RN-50). */
    "mural.mover": {
        metodo: "PUT",
        caminho: "/api/mural/:id/posicao",
        params: zMuralId,
        corpo: zPosicaoNoMural,
        resposta: zOk,
        autenticada: true,
    },
    /** A reordenação explícita da tela estreita: a lista inteira, na ordem nova. */
    "mural.reordenar": {
        metodo: "PUT",
        caminho: "/api/mural/ordem",
        params: null,
        corpo: zOrdemDoMural,
        resposta: zMural,
        autenticada: true,
    },
    "mural.excluir": {
        metodo: "DELETE",
        caminho: "/api/mural/:id",
        params: zMuralId,
        corpo: null,
        resposta: zMural,
        autenticada: true,
    },
    "estatistica.painel": {
        metodo: "POST",
        caminho: "/api/estatisticas",
        params: null,
        // POST com corpo, não GET com query: é a forma que o contrato já usa para
        // leitura parametrizada (ver `nota.consultar`), e o Zod valida do mesmo
        // jeito nos dois lados.
        corpo: zConsultaDeEstatisticas,
        resposta: zPainelDeEstatisticas,
        autenticada: true,
    },
    "trilha.ferias": {
        metodo: "POST",
        caminho: "/api/trilhas/:id/ferias",
        params: zTrilhaId,
        corpo: zFeriasEntrada,
        resposta: zPainelDaHome,
        autenticada: true,
    },
    "dosagem.ler": {
        metodo: "GET",
        caminho: "/api/dosagem",
        params: null,
        corpo: null,
        resposta: z.object({
            itens: z.array(z.object({ categoriaId: z.string(), alvoDiario: z.number().int() })),
        }),
        autenticada: true,
    },
    "dosagem.definir": {
        metodo: "PUT",
        caminho: "/api/dosagem",
        params: null,
        corpo: zDosagemEntrada,
        resposta: zPainelDaHome,
        autenticada: true,
    },
    "revisao.painel": {
        metodo: "GET",
        caminho: "/api/revisao",
        params: null,
        corpo: null,
        resposta: zPainelDeRevisao,
        autenticada: true,
    },
    "estudo.ajustar": {
        metodo: "POST",
        caminho: "/api/estudo/ajuste",
        params: null,
        corpo: zAjustarEntrada,
        resposta: z.object({ agendamento: zAgendamentoVisivel }),
        autenticada: true,
    },
    /**
     * Só é chamada com o modo ônibus ligado. Ver `zPacoteOffline`.
     */
    "estudo.pacote": {
        metodo: "GET",
        caminho: "/api/estudo/pacote",
        params: null,
        corpo: null,
        resposta: zPacoteOffline,
        autenticada: true,
    },
    "estudo.encerrar": {
        metodo: "POST",
        caminho: "/api/estudo/encerramento",
        params: null,
        corpo: zEncerrarEntrada,
        resposta: zEstudoAtual,
        autenticada: true,
    },
    // --- importação (RN-21 a RN-25) ---
    /**
     * Validação **prévia**: nada é gravado. É a rota que o botão "Conferir"
     * chama, e o relatório dela é o que o usuário vê antes de confirmar.
     */
    "importacao.validar": {
        metodo: "POST",
        caminho: "/api/importacoes/validacao",
        params: null,
        corpo: zImportacaoEntrada,
        resposta: zRelatorio,
        autenticada: true,
    },
    "importacao.confirmar": {
        metodo: "POST",
        caminho: "/api/importacoes",
        params: null,
        corpo: zConfirmarImportacao,
        resposta: zImportacaoFeita,
        autenticada: true,
    },
    "lote.listar": {
        metodo: "GET",
        caminho: "/api/lotes",
        params: null,
        corpo: null,
        resposta: zListaDeLotes,
        autenticada: true,
    },
    "lote.excluir": {
        metodo: "POST",
        caminho: "/api/lotes/:id/exclusao",
        params: zLoteId,
        corpo: zLoteExclusao,
        resposta: zListaDeLotes,
        autenticada: true,
    },
    // --- caderno (RN-29) ---
    "categoria.listar": {
        metodo: "GET",
        caminho: "/api/categorias",
        params: null,
        corpo: null,
        resposta: zListaDeCategorias,
        autenticada: true,
    },
    /**
     * Busca é consulta com corpo, então é POST. O contrato ainda não tem
     * parâmetro de query, e forçar um GET com filtro na URL exigiria a mudança
     * estrutural só por causa desta rota.
     */
    "nota.consultar": {
        metodo: "POST",
        caminho: "/api/notas/consulta",
        params: null,
        corpo: zConsultaDeNotas,
        resposta: zListaDeNotas,
        autenticada: true,
    },
    "nota.ver": {
        metodo: "GET",
        caminho: "/api/notas/:id",
        params: zNotaId,
        corpo: null,
        resposta: zNotaUma,
        autenticada: true,
    },
    "nota.criar": {
        metodo: "POST",
        caminho: "/api/notas",
        params: null,
        corpo: zNotaEntrada,
        resposta: zNotaUma,
        autenticada: true,
    },
    "nota.salvar": {
        metodo: "PUT",
        caminho: "/api/notas/:id",
        params: zNotaId,
        corpo: zSalvarNota,
        resposta: zNotaSalva,
        autenticada: true,
    },
    /** Abre a página do assunto do item, criando-a se não houver (RN-43). */
    "nota.doItem": {
        metodo: "POST",
        caminho: "/api/notas/do-item/:id",
        params: zItemAlvo,
        corpo: null,
        resposta: zNotaDoAssunto,
        autenticada: true,
    },
    /** Matéria, pasta e páginas do item, sem criar nada: o caderno da sessão. */
    "nota.contextoDoItem": {
        metodo: "GET",
        caminho: "/api/notas/contexto-do-item/:id",
        params: zItemAlvo,
        corpo: null,
        resposta: zContextoDoItem,
        autenticada: true,
    },
    // --- inteligência artificial (RN-61 a RN-63) ---
    "ia.estado": {
        metodo: "GET",
        caminho: "/api/ia",
        params: null,
        corpo: null,
        resposta: zEstadoDaIa,
        autenticada: true,
    },
    /** Cadastra a chave desta conta. Ela entra cifrada e nunca volta. */
    "ia.salvarChave": {
        metodo: "POST",
        caminho: "/api/ia/chave",
        params: null,
        corpo: zChaveDaIa,
        resposta: zEstadoDaIa,
        autenticada: true,
    },
    "ia.apagarChave": {
        metodo: "POST",
        caminho: "/api/ia/chave/exclusao",
        params: null,
        corpo: null,
        resposta: zEstadoDaIa,
        autenticada: true,
    },
    /** Gera um lote e o devolve **validado, não gravado** (RN-21). */
    "ia.gerarItens": {
        metodo: "POST",
        caminho: "/api/ia/itens",
        params: null,
        corpo: zPedidoDeItensIa,
        resposta: zItensGerados,
        autenticada: true,
    },
    /** Um bloco de prova em itens, sem gravar — ADR 045. */
    "ia.extrairBloco": {
        metodo: "POST",
        caminho: "/api/ia/extracao/:id",
        params: zFonteId,
        corpo: zPedidoDeExtracao,
        resposta: zBlocoExtraido,
        autenticada: true,
    },
    "ia.tirarDuvida": {
        metodo: "POST",
        caminho: "/api/ia/duvida/:id",
        params: zItemAlvo,
        corpo: zPerguntaDaIa,
        resposta: zRespostaDaIa,
        autenticada: true,
    },
    "ia.explicarErro": {
        metodo: "POST",
        caminho: "/api/ia/erro/:id",
        params: zItemAlvo,
        corpo: null,
        resposta: zRespostaDaIa,
        autenticada: true,
    },
    "nota.excluir": {
        metodo: "POST",
        caminho: "/api/notas/:id/exclusao",
        params: zNotaId,
        corpo: null,
        resposta: zListaDeNotas,
        autenticada: true,
    },
    // --- fontes por categoria e "não entendi" (RN-08) ---
    "fonte.listar": {
        metodo: "GET",
        caminho: "/api/fontes",
        params: null,
        corpo: null,
        resposta: zListaDeFontes,
        autenticada: true,
    },
    "fonte.criar": {
        metodo: "POST",
        caminho: "/api/fontes",
        params: null,
        corpo: zFonteEntrada,
        resposta: zListaDeFontes,
        autenticada: true,
    },
    "fonte.editar": {
        metodo: "PUT",
        caminho: "/api/fontes/:id",
        params: zFonteId,
        corpo: zFonteEntrada,
        resposta: zListaDeFontes,
        autenticada: true,
    },
    /** O texto de uma fonte, para editar (ADR 043). A lista não o carrega. */
    "fonte.texto": {
        metodo: "GET",
        caminho: "/api/fontes/:id/texto",
        params: zFonteId,
        corpo: null,
        resposta: zTextoDaFonte,
        autenticada: true,
    },
    /**
     * Converte um PDF ou uma imagem em Markdown e **devolve sem gravar**: a
     * pessoa confere, corrige, e o texto só vira fonte no `fonte.criar`. O
     * arquivo não toca o disco (ADR 043).
     */
    "fonte.converter": {
        metodo: "POST",
        caminho: "/api/fontes/conversao",
        params: null,
        corpo: zArquivoParaConverter,
        resposta: zTextoDaFonte,
        autenticada: true,
    },
    "fonte.excluir": {
        metodo: "POST",
        caminho: "/api/fontes/:id/exclusao",
        params: zFonteId,
        corpo: null,
        resposta: zListaDeFontes,
        autenticada: true,
    },
    "estudo.naoEntendi": {
        metodo: "POST",
        caminho: "/api/estudo/duvidas",
        params: null,
        corpo: zNaoEntendiEntrada,
        resposta: zNaoEntendiResposta,
        autenticada: true,
    },
    "duvida.listar": {
        metodo: "GET",
        caminho: "/api/duvidas",
        params: null,
        corpo: null,
        resposta: zListaDeDuvidas,
        autenticada: true,
    },
    "duvida.resolver": {
        metodo: "POST",
        caminho: "/api/duvidas/:id/resolucao",
        params: zDuvidaId,
        corpo: zResolverDuvida,
        resposta: zListaDeDuvidas,
        autenticada: true,
    },
    // Eixos independentes do acerto (RN-07): marcar e "não entendi" não são desempenho.
    "item.marcar": {
        metodo: "POST",
        caminho: "/api/itens/:id/marcacao",
        params: zItemAlvo,
        corpo: null,
        resposta: zMarcacaoAlterada,
        autenticada: true,
    },
    "item.marcados": {
        metodo: "GET",
        caminho: "/api/marcados",
        params: null,
        corpo: null,
        resposta: zListaDeMarcados,
        autenticada: true,
    },
    // --- simulado por modelo de prova (RN-26, RN-27, RN-34) ---
    "simulado.painel": {
        metodo: "GET",
        caminho: "/api/simulados",
        params: null,
        corpo: null,
        resposta: zPainelDoSimulado,
        autenticada: true,
    },
    "modeloProva.criar": {
        metodo: "POST",
        caminho: "/api/modelos-de-prova",
        params: null,
        corpo: zModeloProvaEntrada,
        resposta: zModeloProva,
        autenticada: true,
    },
    "modeloProva.editar": {
        metodo: "PUT",
        caminho: "/api/modelos-de-prova/:id",
        params: zModeloProvaId,
        corpo: zModeloProvaEntrada,
        resposta: zModeloProva,
        autenticada: true,
    },
    "modeloProva.excluir": {
        metodo: "DELETE",
        caminho: "/api/modelos-de-prova/:id",
        params: zModeloProvaId,
        corpo: null,
        resposta: zOk,
        autenticada: true,
    },
    /** Monta a prova. A disponibilidade (RN-27) é conferida aqui, no servidor. */
    "simulado.montar": {
        metodo: "POST",
        caminho: "/api/modelos-de-prova/:id/simulado",
        params: zModeloProvaId,
        corpo: null,
        resposta: zMontarSimulado,
        autenticada: true,
    },
    /** Entrega a prova. Idempotente: entregar duas vezes não reconta. */
    "simulado.encerrar": {
        metodo: "POST",
        caminho: "/api/simulados/:id/encerramento",
        params: zSimuladoId,
        corpo: null,
        resposta: zRelatorioDeSimulado,
        autenticada: true,
    },
    "simulado.relatorio": {
        metodo: "GET",
        caminho: "/api/simulados/:id",
        params: zSimuladoId,
        corpo: null,
        resposta: zRelatorioDeSimulado,
        autenticada: true,
    },
};
export const CHAVES_ROTA = Object.keys(contrato);
/** Os nomes dos `:parametro` de um caminho, na ordem em que aparecem. */
export function parametrosDoCaminho(caminho) {
    return caminho
        .split("/")
        .filter((s) => s.startsWith(":"))
        .map((s) => s.slice(1));
}
/**
 * Troca cada `:nome` pelo valor correspondente, já escapado.
 *
 * Fica aqui, e não no cliente do navegador, para poder ser testada sem DOM e
 * para que qualquer outro consumidor do contrato monte a URL do mesmo jeito.
 */
export function montarCaminho(caminho, params) {
    const nomes = parametrosDoCaminho(caminho);
    if (nomes.length === 0)
        return caminho;
    if (!params)
        throw new Error(`O caminho ${caminho} exige os parâmetros ${nomes.join(", ")}, e nenhum foi passado.`);
    return caminho
        .split("/")
        .map((s) => {
        if (!s.startsWith(":"))
            return s;
        const nome = s.slice(1);
        const valor = params[nome];
        if (valor === undefined || valor === "") {
            throw new Error(`O parâmetro ${nome} de ${caminho} veio vazio.`);
        }
        return encodeURIComponent(valor);
    })
        .join("/");
}
/**
 * Confere que `params` e o caminho contam a mesma história.
 *
 * Um `:id` no caminho sem chave em `params` viraria `undefined` na URL; uma
 * chave em `params` sem `:id` no caminho seria validação que nunca roda. Os
 * dois são erros silenciosos, então isto é exercitado em teste — o invariante 2
 * vale para os parâmetros também, não só para a existência da rota.
 */
export function conferirCoerenciaDoContrato() {
    const problemas = [];
    for (const chave of CHAVES_ROTA) {
        const def = contrato[chave];
        const noCaminho = parametrosDoCaminho(def.caminho);
        if (noCaminho.length === 0) {
            if (def.params)
                problemas.push(`${chave}: tem schema de params mas o caminho não tem nenhum :parametro`);
            continue;
        }
        if (!def.params) {
            problemas.push(`${chave}: o caminho pede ${noCaminho.join(", ")} mas params é null`);
            continue;
        }
        const forma = def.params;
        if (!forma.shape) {
            problemas.push(`${chave}: params precisa ser um z.object para ser conferido`);
            continue;
        }
        const noSchema = Object.keys(forma.shape);
        for (const nome of noCaminho) {
            if (!noSchema.includes(nome))
                problemas.push(`${chave}: :${nome} está no caminho e falta em params`);
        }
        for (const nome of noSchema) {
            if (!noCaminho.includes(nome))
                problemas.push(`${chave}: params declara ${nome}, que não existe no caminho`);
        }
    }
    return problemas;
}
//# sourceMappingURL=contrato.js.map